import e from"styled-components";const i=e.div`
	display: flex;
	flex-direction: column;
	gap: 6px;
`,n=e.div`
	padding: 8px;
	background-color: #fbfbfa;
	border-radius: 8px;
	display: flex;
	align-items: center;
	justify-content: space-between;
`,o=e.div`
	display: flex;
	align-items: center;
	gap: 4px;
`,t=e.div`
	font-size: 14px;
	color: #171717;
	user-select: none;
`,r=e.div`
	display: grid;
	place-content: center;
	cursor: ${({cursor:e="default"})=>e};
`;export{r as IconContainer,i as PeopleContainer,n as PersonContainer,o as PersonDataContainer,t as PersonName};
